export default {"src":"/_next/static/media/yatsan-pin.a054856b.svg","height":58,"width":48,"blurWidth":0,"blurHeight":0};